import { ActionTypes } from "../constants/ActionTypes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CurrencySymbol, TOASTER_MESSAGES } from "../../utils/Constants";
import { API_ENDPOINTS } from "../../utils/api-endpoints";
import { ReactProjectBaseUrl } from "../../utils/Constants";
//import { getApiToken } from '../../utils/get-token';
import axios from "axios";
import Swal from "sweetalert2";
import { AddToCart, AddToCartReorder } from "../actions/addToCartActions";
import {
  getApiToken,
  getBranchToken,
  isGeofenchingEnabled,
} from "../../utils/get-token";
import { defaultImage } from "../../utils/productUtils/ProductUtils";
import { globalSwalFunction } from "../../utils/globalFunctions/globalSwal";
import Cookies from "js-cookie";

const notifyToast = (title, type) => {
  const options = {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };
  switch (type) {
    case "success":
      toast.success(title, options);
      break;
    case "warning":
      toast.warning(title, options);
      break;
    case "error":
      toast.error(title, options);
      break;
    case "info":
      toast.info(title, options);
      break;

    default:
      toast.info(title, options);
      break;
  }
};

export const getAllOrderList = (contactId) => async (dispatch, getState) => {
  const token = isGeofenchingEnabled() == 1 ? getBranchToken() : getApiToken();
  let orderListResponse = [];

  const accessToken = Cookies.get("accessToken");

  try {
    const res = await axios.get(
      ReactProjectBaseUrl + API_ENDPOINTS.GET_SALES_LIST,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          API_TOKEN: token,
          Authentication: `${accessToken}`,
        },
      }
    );

    orderListResponse = res?.data;

    const orderListNewResponse = orderListResponse.response;
    let orderListArray = [];

    if (orderListResponse.status) {
      orderListArray = [...orderListNewResponse.OrderDetails];
    } else {
      orderListArray = [];
    }

    dispatch({ type: ActionTypes.GET_SALES_LIST, payload: orderListArray });
  } catch (error) {
    const refreshToken = Cookies.get("refreshToken");
    if (error?.response?.status === 401) {
      const res = await axios.get(
        `${ReactProjectBaseUrl}/refresh-token?refreshToken=${refreshToken}`
      );

      console.log("res", res);

      if (res?.status == 200) {
        Cookies.set("accessToken", res?.data?.accessToken);
      }
      window.location.reload();
    }
  }
};

// Reset Order List
export const resetOrderList = () => async (dispatch) => {
  dispatch({ type: ActionTypes.RESET_ORDER_LIST, payload: [] });
};

export const getOrderDetails = (salesId) => async (dispatch) => {
  let orderDetailsResponse = [];

  let newOrderList = [];
  const token = isGeofenchingEnabled() == 1 ? getBranchToken() : getApiToken();
  await axios
    .get(
      ReactProjectBaseUrl + API_ENDPOINTS.GET_SALES_DETAILS + "/" + salesId,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          API_TOKEN: token,
        },
      }
    )
    .then((data) => {
      orderDetailsResponse = data.data;
    });

  const orderDetailsNewResponse = orderDetailsResponse.response;

  if (orderDetailsNewResponse) {
    newOrderList = orderDetailsNewResponse.salesList;
  }

  const newOrderArraylist = [...newOrderList];
  dispatch({ type: ActionTypes.GET_SALES_DETAILS, payload: newOrderArraylist });
};

export const cancelOrder = (salesId) => async (dispatch) => {
  const token = isGeofenchingEnabled() == 1 ? getBranchToken() : getApiToken();
  let cancelOrderResponse = {};
  let data = {};
  await axios
    .put(
      ReactProjectBaseUrl + API_ENDPOINTS.CANCEL_ORDER + "/" + salesId,
      data,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          API_TOKEN: token,
        },
      }
    )
    .then((data) => {
      cancelOrderResponse = data.data;
    });

  const cancelOrderNewResponse = cancelOrderResponse;

  if (cancelOrderNewResponse) {
    if (cancelOrderNewResponse.status) {
      // notifyToast("Order Cancelled successfully...!!!", 'success')
      Swal.fire({
        text: "Order cancelled successfully!",
        iconHtml: '<i class="fas fa-check-circle mb-1 text-success fs-5"></i>',
        target: "#custom-target",
        showConfirmButton: false,
        showClass: {
          popup: "animate__animated animate__slideInUp",
        },
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          container: "position-absolute",
        },
        toast: true,
        position: "bottom-right",
      });
    } else {
      // notifyToast("Somthing Went Wrong...!!!", 'error');
      Swal.fire({
        text: "Something went wrong!",
        iconHtml: '<i class="fas fa-times-circle text-danger fs-5"></i>',
        target: "#custom-target",
        showConfirmButton: false,
        showClass: {
          popup: "animate__animated animate__slideInUp",
        },
        //   hideClass: {
        //     popup: 'animate__animated animate__fadeInDown'
        //   },
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          container: "position-absolute",
        },
        toast: true,
        position: "bottom-right",
      });
    }
  } else {
    // notifyToast("No Response found ...!!!", 'error');
    Swal.fire({
      text: "No Response found !",
      iconHtml: '<i class="fas fa-times-circle text-danger fs-5"></i>',
      target: "#custom-target",
      showConfirmButton: false,
      showClass: {
        popup: "animate__animated animate__slideInUp",
      },
      //   hideClass: {
      //     popup: 'animate__animated animate__fadeInDown'
      //   },
      timer: 2000,
      timerProgressBar: true,
      customClass: {
        container: "position-absolute",
      },
      toast: true,
      position: "bottom-right",
    });
  }

  dispatch({ type: ActionTypes.CANCEL_ORDER, payload: cancelOrderNewResponse });

  if (cancelOrderNewResponse) {
    return true;
  } else {
    return false;
  }
};

export const getOrderTrackingTrail = (salesId) => async (dispatch) => {
  const token = isGeofenchingEnabled() == 1 ? getBranchToken() : getApiToken();
  let orderTrackingTrailResponse = [];

  let newOrderTrackingTrailList = [];
  const data = "";
  await axios
    .post(
      ReactProjectBaseUrl +
        API_ENDPOINTS.FETCH_ORDER_TRACKING_TRAIL +
        "/" +
        salesId,
      data,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          API_TOKEN: token,
        },
      }
    )
    .then((data) => {
      orderTrackingTrailResponse = data.data;
    });

  const orderDetailsNewResponse = orderTrackingTrailResponse.response;

  if (orderDetailsNewResponse) {
    newOrderTrackingTrailList = orderDetailsNewResponse;
  }

  const newOrderArraylist = [...newOrderTrackingTrailList];
  dispatch({
    type: ActionTypes.GET_SALES_TRACKING_TRAIL,
    payload: newOrderArraylist,
  });
};

export const reOrderAction = (salesId) => async (dispatch, getState) => {
  try {
    let orderDetailsResponse = [];
    const token =
      isGeofenchingEnabled() == 1 ? getBranchToken() : getApiToken();
    const cartItems = getState().cartItems;
    await axios
      .get(
        ReactProjectBaseUrl + API_ENDPOINTS.REORDER + "?salesId=" + salesId,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            API_TOKEN: token,
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        }
      )
      .then((data) => {
        orderDetailsResponse = data.data;
      });

    if (orderDetailsResponse.status) {
      const orderDetailsNewResponse = orderDetailsResponse.response;
      if (orderDetailsNewResponse.length > 0) {
        orderDetailsNewResponse.map((availableDetail) => {
          let filteredArray = cartItems.filter(
            (x) => x.productVarientId == availableDetail.product_varient_id
          );

          if (filteredArray.length > 0) {
            let finalQty = 0;
            let quantity = filteredArray[0].quantity + availableDetail.qty;
            if (quantity >= availableDetail.availablequantity) {
              finalQty = availableDetail.availablequantity;
            } else if (quantity < availableDetail.availablequantity) {
              finalQty = filteredArray[0].quantity + availableDetail.qty;
            }

            const fetchQty = finalQty >= 15 ? 15 : finalQty;
            if (finalQty >= 15) {
              dispatch(
                AddToCartReorder(
                  availableDetail.product_varient_id,
                  availableDetail.sellingprice,
                  availableDetail.logo ? availableDetail.logo : defaultImage,
                  availableDetail.name,
                  availableDetail.product_id,
                  Math.floor(fetchQty),
                  Math.floor(availableDetail.availablequantity),
                  availableDetail.varient_name,
                  availableDetail.activeonline
                )
              );
              Swal.fire({
                text: "Maximum limit reached!",
                iconHtml:
                  '<i class="fas fs-5 fa-check-circle text-success "></i>',
                target: "#custom-target",
                showConfirmButton: false,
                showClass: {
                  popup: "animate__animated animate__slideInUp",
                },
                //   hideClass: {
                //     popup: 'animate__animated animate__fadeInDown'
                //   },
                timer: 2000,
                timerProgressBar: true,
                customClass: {
                  container: "position-absolute",
                },
                toast: true,
                position: "bottom-right",
              });
            } else {
              dispatch(
                AddToCartReorder(
                  availableDetail.product_varient_id,
                  availableDetail.sellingprice,
                  availableDetail.logo ? availableDetail.logo : defaultImage,
                  availableDetail.name,
                  availableDetail.product_id,
                  Math.floor(finalQty),
                  Math.floor(availableDetail.availablequantity),
                  availableDetail.varient_name,
                  availableDetail.activeonline
                )
              );
            }
          } else {
            let finalQty = 0;
            if (availableDetail.qty >= availableDetail.availablequantity) {
              finalQty = availableDetail.availablequantity;
            } else {
              finalQty = availableDetail.qty;
            }
            if (finalQty >= 15) {
              Swal.fire({
                text: "Maximum limit reached!",
                iconHtml:
                  '<i class="fas fs-5 fa-check-circle text-success "></i>',
                target: "#custom-target",
                showConfirmButton: false,
                showClass: {
                  popup: "animate__animated animate__slideInUp",
                },
                //   hideClass: {
                //     popup: 'animate__animated animate__fadeInDown'
                //   },
                timer: 2000,
                timerProgressBar: true,
                customClass: {
                  container: "position-absolute",
                },
                toast: true,
                position: "bottom-right",
              });
            }
            dispatch(
              AddToCartReorder(
                availableDetail.product_varient_id,
                availableDetail.sellingprice,
                availableDetail.logo ? availableDetail.logo : defaultImage,
                availableDetail.name,
                availableDetail.product_id,
                Math.floor(finalQty),
                Math.floor(availableDetail.availablequantity),
                availableDetail.varient_name,
                availableDetail.activeonline
              )
            );
            Swal.fire({
              text: `${TOASTER_MESSAGES.ADD_TO_CART_MESSAGE}`,
              iconHtml:
                '<i class="fas fs-5 fa-check-circle text-success "></i>',
              target: "#custom-target",
              showConfirmButton: false,
              showClass: {
                popup: "animate__animated animate__slideInUp",
              },
              //   hideClass: {
              //     popup: 'animate__animated animate__fadeInDown'
              //   },
              timer: 2000,
              timerProgressBar: true,
              customClass: {
                container: "position-absolute",
              },
              toast: true,
              position: "bottom-right",
            }).then(() => {
              const cartReady = orderDetailsNewResponse.some(
                (items) =>
                  items.availablequantity <= 0 ||
                  items.activeonline == 0 ||
                  items.qty > items.availablequantity
              );
              if (cartReady) {
                globalSwalFunction(
                  "There are some changes in your cart",
                  '<i class="fas fa-times-circle text-danger fs-5"></i>'
                );
              }
            });
          }
        });
      }
    }
  } catch (error) {
    console.error("errorvvvvvv)", error);
  }
};
